import { Notification } from '../Types/notifications';
import { notificationPathUrl } from '../util/routesUrls';
import { API_URL, enrichedFetch } from './api';

export const dismissNotification = (notificationId: string) => {
  return enrichedFetch(`${API_URL}/${notificationPathUrl(notificationId)}`, {
    method: 'PATCH',
  }) as Promise<Notification>;
};
